import { InfoIconTooltip } from '@/core/features';
import { bemModule } from '@/core/utils/bem-classname';

import styles from './sort-bar.module.scss';

const bem = bemModule(styles);

export type SortBarOption = {
    info: {
        htmlInfoText: string;
        htmlInfoTitle: null | string;
    } | null;
    isSelected: boolean;
    label: string;
    name: string;
};

type SortBarProps = {
    onClickOption?: (option: SortBarOption) => void;
    options: Array<SortBarOption>;
};

export default function SortBar({ onClickOption, options }: SortBarProps) {
    return (
        <div className={'flex-center'}>
            {options.map((option, index) => {
                const last = index === options.length - 1;
                const showDivider = !last && !options[index + 1]?.isSelected && !option.isSelected;

                return (
                    <div
                        className={`flex-center ${bem(styles.option, { selected: option.isSelected })}`}
                        key={`${option.name}-${index}`}
                        onClick={() => onClickOption?.(option)}
                    >
                        <div className={`flex-center ${styles.content}`}>
                            <div className={'ellipsis'}>{option.label}</div>
                            {option.info && (
                                <InfoIconTooltip
                                    htmlInfoText={option.info.htmlInfoText}
                                    htmlInfoTitle={option.info.htmlInfoTitle}
                                    iconSize={16}
                                    qaId={'qa-sort-bar-info'}
                                    tippyConfig={{
                                        hideOnClick: false,
                                        placement: 'right',
                                    }}
                                />
                            )}
                        </div>
                        {showDivider && <div className={styles.divider} />}
                    </div>
                );
            })}
        </div>
    );
}
